<template>
  <div class="warp" :style="{'--themeColor': themeColor}">
    <router-view/>
  </div>
</template>

<script>

export default {
  data() {
    return {
      // themeColor: '#930000'
      themeColor: ''
    };
  },

  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },

    getThemeColor() {
      let fid = this.$route.query.museumCode || this.$cookie.get('museumCode')
      if (isNaN(Number(fid))) return this.themeColor = '#930000'
      let data = {
        deptId: this.$route.query.museumCode || this.$cookie.get('museumCode'),
        formId: 354608,
        limit: 10,
        page: 1
      }
      this.$ajax(`/api/micro-backend/front/form/advance-search?deptId=${fid}&formId=354608&limit=10&page=1`).then((res) =>{
        res = res.data
        if (!res.success || !res.data.dataList || !res.data.dataList.length) return this.themeColor = '#930000'
        res = res.data.dataList
        let color = res[0].formIdValueData['color'].groupValues[0].values[0][0].val.split('(')[1]
        this.themeColor = color.replace(')', '')
        let pcBg = res[0].formIdValueData[14].groupValues[0].values[0][0]
        let h5Bg = res[0].formIdValueData[15].groupValues[0].values[0][0]
        this.$store.state.themeData = {
          pcBg: pcBg ? `https://museum.chaoxing.com/star3/origin/${pcBg.objectId}.${pcBg.suffix}` : '',
          h5Bg: h5Bg ? `https://museum.chaoxing.com/star3/origin/${h5Bg.objectId}.${h5Bg.suffix}` : '',
        }
      })
    }
  },

  mounted() {
    this.getThemeColor()
    if (this._isMobile()) {
      this.$store.state.isMobile = true
    } else{
      this.$store.state.isMobile = false
    }
  },
}
</script>

<style lang="scss">
@font-face {
  font-family: DNXSJW;
  src: url("~@/assets/fonts/FZZJ-DNXSJW.TTF")
}
@font-face {
  font-family: FZDBSJW;
  src: url("../../assets/fonts/FZDBSJW.TTF")
}
/* 滚动条样式 */
::-webkit-scrollbar{
  width: 10px;
  height: 10px;
  display: block;
  /**/
}
::-webkit-scrollbar-track{
  background: rgba(0,0,0,0);
  border-radius:4px;
}
::-webkit-scrollbar-thumb{
  background: #33333312;
  border-radius:4px;
}
::-webkit-scrollbar-corner{
  background: rgba(0,0,0,0);
}
// 主题色
$themeColor: var(--themeColor);
.home .content .museumTime,.logo .logoContent .timeAndDate,.reservation .fileDemo, .reservation .activeGroup, .reservation .addNewGroup, .orderDetail .leftName .index, .register .registerInput span, .register .h5Login .registerInput span, .venueList .title, .writeOffMuseum .tips, .explainInfo{
  color: $themeColor;
}
.groupCode .focused, .loginContent .el-input__inner, .reservation .activeGroup, .orderCheck .el-checkbox__inner, .orderDetail .el-checkbox__inner{
  border: 1px solid $themeColor !important;
}
.logo .h5Login .button1, .register .h5Login .button1, .personalCard .left:after{
  background-color: $themeColor;
}
.venueList .header{
  background-image: linear-gradient(270deg,$themeColor,#191919);
}
// 个人中心
.personalCenter {
  .loginOut{
    color: $themeColor;
    border: 1px solid $themeColor;
  }
  .nameWarp{
    background: $themeColor;
    div:before{
      background-color: $themeColor;
      -webkit-mask: url('~@/assets/ticket/user-filling.svg') 0 0/100% 100% no-repeat;
      mask: url('~@/assets/ticket/user-filling.svg') 0 0/100% 100% no-repeat;
    }
  }
  .line{
    &:before{
      background-color: $themeColor;
    }
  }
  .contacts{
    .buttons{
      color: $themeColor;
    }
  }
}
// 新的订单
.ordersNew{
  .personalCard{
    .orderStatus{
      color: $themeColor;
    }
  }
}
.innerWarp .banner .innerBgColor{
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0;
  top:0;
  background: -moz-linear-gradient(left, $themeColor 15%, rgba(0,0,0,0) 100%);
  background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,$themeColor), color-stop(100%,rgba(0,0,0,0)));
  background: -webkit-linear-gradient(left, $themeColor 15%,rgba(0,0,0,0) 100%);
  background: -o-linear-gradient(left, $themeColor 15%,rgba(0,0,0,0) 100%);
  background: -ms-linear-gradient(left, $themeColor 15%,rgba(0,0,0,0) 100%);
  background: linear-gradient(to right, $themeColor 15%,rgba(0,0,0,0) 100%);
  z-index: -1;
}
.closeReservation{
  color: $themeColor;
}
#app {
  font-family: SourceHanSerifCN-Bold, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #333;
}
.contentCard{
  width: 8rem;
  margin: 0 0.5rem;
  margin-top: 0.5rem;
  background-color: #f6f6f6;
  border-radius: 0.3rem;
  padding: 0.5rem;
  text-align: left;
}
// button

// 手机端的普通按钮
.buttonNormal{
  width: 4rem;
  height: 1rem;
  font-size: 0.5rem;
  color: $themeColor;
  line-height: 1rem;
  margin: 0 3rem;
  cursor: pointer;
  position: relative;
  &:after{
    width: 100%;
    height: 100%;
    display: block;
    content: '';
    position: absolute;
    top: 0;
    left:0;
    z-index: -1;
    background-color: $themeColor;
    -webkit-mask: url('~@/assets/buttonBgc.svg') 0 0/100% 100% no-repeat;
    mask: url('~@/assets/buttonBgc.svg') 0 0/100% 100% no-repeat;
  };
}
.baseLine{
  height: 0.5rem;
  width: 5rem;
  background-color: $themeColor;
  -webkit-mask: url('~@/assets/line.svg') 0 0/100% 100% no-repeat;
  mask: url('~@/assets/line.svg') 0 0/100% 100% no-repeat;
  margin: 0.3rem auto;
}
.logo{
  .inputPhone::before{
    background-color: $themeColor;
    -webkit-mask: url('~@/assets/ticket/icon3.svg') 0 0/100% 100% no-repeat;
    mask: url('~@/assets/ticket/icon3.svg') 0 0/100% 100% no-repeat;
  }
  .inputCode::before{
    background-color: $themeColor;
    -webkit-mask: url('~@/assets/ticket/icon4.svg') 0 0/100% 100% no-repeat;
    mask: url('~@/assets/ticket/icon4.svg') 0 0/100% 100% no-repeat;
  }
}
.baseLine2{
  height: 1.5rem;
  width: 0.2rem;
  background: url('~@/assets/line2.png') 0 0/contain no-repeat;
  margin: 0.3rem auto;
}

// 手机端的确认按钮
.buttonConfirm{
  width: 3rem;
  height: 0.8rem;
  background-color: $themeColor;
  color: #fff;
  font-size: 0.4rem;
  line-height: 0.8rem;
  margin: auto;
  margin-top: 0.5rem;
  border-radius: 0.5rem;
  cursor: pointer;
}
// 手机端取消按钮
.buttonCancel{
  width: 2.98rem;
  height: 0.8rem;
  background-color: #fff;
  color: $themeColor;
  font-size: 0.4rem;
  line-height: 0.78rem;
  margin: auto;
  margin-top: 0.5rem;
  border-radius: 0.5rem;
  border: 0.02rem solid $themeColor;
  cursor: pointer;
}

// 文案按钮
.buttonText{
  font-size: 0.4rem;
  color: $themeColor;
  cursor: pointer;
}

// pc端普通无背景圆角按钮
.button1{
  font-size: 0.08rem;
  color: $themeColor;
  padding: 0.04rem 0.05rem;
  border: 1px solid $themeColor;
  border-radius: 0.14rem;
  width: 0.5rem;
  cursor: pointer;
}

.buttonSumbit{
  width: 1rem;
  height: 0.4rem;
  background-color: $themeColor;
  border-radius: 0.1rem;
  color: #fff;
  font-size: 0.12rem;
  line-height: 0.4rem;
  cursor: pointer;
}

.button2{
  // background: url('~@/assets/ticket/buttonSmall.svg') 0 0/100% 100% no-repeat;
  width: 158px;
  height: 81px;
  line-height: 81px;
  color: $themeColor;
  font-size: 22px;
  cursor: pointer;
  position: relative;
  &:after{
    width: 100%;
    height: 100%;
    display: block;
    content: '';
    position: absolute;
    top: 0;
    left:0;
    z-index: -1;
    background-color: $themeColor;
    -webkit-mask: url('~@/assets/ticket/buttonSmall.svg') 0 0/100% 100% no-repeat;
    mask: url('~@/assets/ticket/buttonSmall.svg') 0 0/100% 100% no-repeat;
  };
}

.button3{
  width: 355px;
  height: 81px;
  line-height: 81px;
  color: #fff;
  font-size: 22px;
  cursor: pointer;
  position: relative;
  &:after{
    width: 100%;
    height: 100%;
    display: block;
    content: '';
    position: absolute;
    top: 0;
    left:0;
    z-index: -1;
    background-color: $themeColor;
    -webkit-mask: url('~@/assets/ticket/11.svg') 0 0/100% 100% no-repeat;
    mask: url('~@/assets/ticket/11.svg') 0 0/100% 100% no-repeat;
  };
}
.button3_f{
  &:after{
    background-color: $themeColor;
    -webkit-mask: url('~@/assets/ticket/buttonNormal.svg') 0 0/100% 100% no-repeat;
    mask: url('~@/assets/ticket/buttonNormal.svg') 0 0/100% 100% no-repeat;
  }
}
.tuan{
  background-color: $themeColor;
  -webkit-mask: url('~@/assets/ticket/tuan.svg') 0 0/100% 100% no-repeat;
  mask: url('~@/assets/ticket/tuan.svg') 0 0/100% 100% no-repeat;
}
.pcButton3{
  width: 315px;
  height: 65px;
  line-height: 65px;
}
.addGroup{
  background-color: $themeColor;
  height: 40px;
  width: 150px;
  line-height: 40px;
  text-align: center !important;
  border-radius: 25px;
  font-size: 22px !important;
  margin-bottom: 0 !important;
}
.button4{
  // background: url('~@/assets/ticket/button4.png') 0 0/100% 100% no-repeat;
  height: 80px;
  width: 330px;
  line-height: 80px;
  color: $themeColor;
  font-size: 24px;
  cursor: pointer;
  margin-right: 50px;
  position: relative;
  &:after{
    width: 100%;
    height: 100%;
    display: block;
    content: '';
    position: absolute;
    top: 0;
    left:0;
    z-index: -1;
    background-color: $themeColor;
    -webkit-mask: url('~@/assets/ticket/button4.svg') 0 0/100% 100% no-repeat;
    mask: url('~@/assets/ticket/button4.svg') 0 0/100% 100% no-repeat;
  };
}

.pcButtonWarp{
  // display: flex;
  // align-items: center;
}

.buttonWhite{
  // background: url('~@/assets/ticket/buttonWhite.png') 0 0/100% no-repeat;
  color: $themeColor;
  font-size: 20px;
  line-height: 56px;
  width: 268px;
  height: 56px;
  cursor: pointer;
  position: relative;
  &:after{
    width: 100%;
    height: 100%;
    display: block;
    content: '';
    position: absolute;
    top: 0;
    left:0;
    z-index: -1;
    background-color: $themeColor;
    -webkit-mask: url('~@/assets/ticket/buttonWhite.svg') 0 0/100% 100% no-repeat;
    mask: url('~@/assets/ticket/buttonWhite.svg') 0 0/100% 100% no-repeat;
  };
}

.buttonRed{
  color: #fff;
  font-size: 22px;
  line-height: 56px;
  width: 268px;
  height: 56px;
  cursor: pointer;
  position: relative;
  &:after{
    width: 100%;
    height: 100%;
    display: block;
    content: '';
    position: absolute;
    top: 0;
    left:0;
    z-index: -1;
    background-color: $themeColor;
    -webkit-mask: url('~@/assets/ticket/buttonRed.svg') 0 0/100% 100% no-repeat;
    mask: url('~@/assets/ticket/buttonRed.svg') 0 0/100% 100% no-repeat;
  };
}

.el-radio__label{
  // font-size: 0.38rem;
}

// pc端
.topBanner{
  background-image: linear-gradient(270deg, $themeColor 0%, #191919 100%);
}

.itemTitle{
  font-size: 26px;
  font-weight: 500;
  text-align: left;
  padding-left: 45px;
  position: relative;
  margin-bottom: 28px;
  &:before{
    position: absolute;
    top: 2px;
    left: 0;
    height: 32px;
    width: 32px;
    content: '';
    display: inline-block;
    background-color: $themeColor;
    -webkit-mask: url('~@/assets/ticket/icon.svg') 0 0/100% 100% no-repeat;
    mask: url('~@/assets/ticket/icon.svg') 0 0/100% 100% no-repeat;
  }
}

.pcToIndex{
  border: 1px solid #333333;
  color: #333333;
  width: 100px;
  height: 40px;
  line-height: 40px;
  border-radius: 20px;
  font-size: 16px;
  cursor: pointer;
}

.pcContent{
  width: 1200px;
  margin: auto;
  margin-top: 0.3rem;
  font-size: 0.1rem;
}
.resText{
  color: $themeColor;
}
.calendar td.selected{
  color: #fff;
  z-index: 22;
}
.calendar td.selected::after{
  display: inline;
  content: '';
  height: 1rem;
  width: 1rem;
  background-color: $themeColor;
  border-radius: 50%;
  color: #fff;
  position: absolute;
  top: 0.17rem;
  left: 0.05rem;
  z-index: -1;
}
.reSuccess{
  .dateNow{
    color: $themeColor;
  }
}
// 灰色背景卡
.itemCard{
  margin: 0.5rem;
  background-color: #f6f6f6;
  padding: 0.5rem;
  border-radius: 0.2rem;
}
.pcCalendar{
  &:after{
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    background-color: $themeColor;
    -webkit-mask: url('~@/assets/ticket/date.svg') 0 0/cover no-repeat;
    mask: url('~@/assets/ticket/date.svg') 0 0/cover no-repeat;
    // background: url('~@/assets/ticket/date.png') 0 0/cover no-repeat;
  }
}
.pcContent .itemCard, .pcItemCard{
  background-color: #f6f6f6;
  // padding: 0.2rem 0.4rem;
  padding: 35px 90px;
  border-radius: 20px;
  margin-bottom: 40px;
}
.pcContent .itemCard{
  margin: auto;
}
.pcItemCard{
  .itemCard{
    margin: 0;
    padding: 0 !important;
  }
  .lineBgc{
    // background: url('~@/assets/line2.png') center/contain no-repeat #f6f6f6;
    &:after{
      background: $themeColor;
    }
    display: flex;
  }
  .left, .right{
    width: 450px;
    font-size: 18px;
    text-align: left;
    line-height: 32px;
    max-height: 450px;
    padding-right: 20px;
    overflow-y: scroll;
  }
  .title{
    text-align: center;
    font-weight: 500;
    font-size: 0.15rem;
  }
  .left{
    margin-right: 75px;
  }
  .right{
    margin-left: 40px;
  }
  .buttonText{
    font-size: 16px !important;
    margin-left: 0.1rem;
  }

  .lineContent{
    font-size: 22px;
    height: 40px;
    .name{
      width: 0.8rem;
    }
    .el-input__inner{
      width: 100%;
      text-align: left;
      font-size: 20px;
    }
  }
  .lineContent .el-input{
    width: 70%;
  }
}
.home{
  .pcItemCard{
    .lineBgc{
      .left{
        margin-right: 55px;
      }
      .right{
        margin-left: 0;
        padding-left: 50px;
        border-left: 2px solid $themeColor;
      }
    }
  }
}
.pcContent{
  // pc弹窗
  .popWarp{
    .popDetail{
      .title, .confirmText{
        font-size: 30px;
        font-weight: 500;
        margin: 25px 0;
      }
      min-height: auto;
      padding: 30px 40px;
      width: 500px;
      margin: auto;
      margin-left: calc(50% - 250px);
      border-radius: 20px;
    }
    .tips{
      color: $themeColor;
    }
    .baseLine{
      width: 90%;
      margin: 30px auto;
      height: 40px;
    }
    .buttonConfirm, .buttonCancel{
      width: 260px !important;
      height: 56px;
      line-height: 56px;
      font-size: 24px;
      margin-top: 30px;
    }
    .lineContent{
      height: 50px;
      margin-left: 30px;
      .el-input{
        // width: 1.5rem;
      }
      .name{
        font-size: 20px;
        width: 100px;
        margin-right: 10px;
      }
      .el-input, .el-select{
        width: 300px
      }
      .el-input__inner{
        width: 300px;
        text-align: left;
        font-size: 20px;
      }
    }
  }
  .el-radio-group{
    transform: scale(1.3);
    margin-top: 0.05rem;
    margin-left: 37px;
  }
  .itemContentTitle{
    display: none;
  }
  .buttonText{
    font-size: 0.16rem;
  }
  .el-input__inner{
    color: #fff;
    background-color: unset;
    border: unset;
    text-align: center;
  }
  .el-select .el-input .el-select__caret{
    color: #fff;
  }
  .lineContent .el-select .el-input .el-select__caret{
    color: #333;
    font-weight: 700;
  }
  .lineContent .el-input__suffix{
    right: 0rem;
  }
  .noticeWarp{
    text-align: center;
  }
  .button3{
    // margin: auto;
  }
  .itemCard{
    .nameBlock{
      width: 180px;
      height: 66px;
      border-radius: 16px;
      border-radius: 12px;
      line-height: 66px;
      font-size: 22px;
      cursor: pointer;
      margin: 30px 25px 0 0 !important;
    }
    .nameBlock:nth-child(5n){
      margin-right: 0 !important;
    }
    .nameBlock:nth-child(1),.nameBlock:nth-child(2),.nameBlock:nth-child(3),.nameBlock:nth-child(4),.nameBlock:nth-child(5){
      margin-top: 0 !important;
    }
    .add{
    }
    .nameDetail{
      font-size: 20px;
      margin-top: 30px;
      margin-bottom: 0;
      .buttonText{
        font-size: 20px !important;
      }
      .delName{
        width: 30px;
        height: 30px;
        line-height: 30px;
        cursor: pointer;
        font-size: 20px;
        border-radius: 5px;
      }
      div{
        &:nth-child(2) {
          width: 150px;
          margin-left: 20px;
          font-size: 20px;
        }
        &:nth-child(3) {
          width: 200px;
          margin-right: 30px;
          font-size: 20px;
        }
      }
      .age{
        margin-left: 0;
      }
    }
    .delName{
      height: 0.4rem;
      width: 0.4rem;
      border-radius: 0.05rem;
      line-height: 0.3rem;
      font-size: 0.14rem;
    }
    .nameWarp .selected{
      border: 2px solid $themeColor;
      position: relative;
      width: 178px;
      height: 64px;
      line-height: 64px;
      border-radius: 12px;
      &:after{
        bottom: -2px;
        right: -2px;
        display: inline-block;
        content: '';
        position: absolute;
        width: 40px;
        height: 40px;
        border-bottom-right-radius: 8px;
        background-color: $themeColor;
        -webkit-mask: url('~@/assets/ticket/buttonSelect.svg') 0 0/cover no-repeat;
        mask: url('~@/assets/ticket/buttonSelect.svg') 0 0/cover no-repeat;
      }
    }
    .itemWarp{
      justify-content: flex-start;
      height: 0.4rem;
      margin-bottom: 0
    }
    .contentTitle{
      font-size: 0.13rem;
      position: relative;
      padding-left: 0.2rem;
      &:before{
        position: absolute;
        top: 0.01rem;
        left: 0;
        height: 32px;
        width: 32px;
        content: '';
        display: inline-block;
        background-color: $themeColor;
        -webkit-mask: url('~@/assets/ticket/icon.svg') 0 0/100% 100% no-repeat;
        mask: url('~@/assets/ticket/icon.svg') 0 0/100% 100% no-repeat;
      }
    }
  }
  .itemWarpLine{
    display: inline-block;
    font-size: 20px !important;
    margin-top: 0;
    margin-bottom: 0;
    .notice{
      margin-left: 0.15rem;
      cursor: pointer;
    }
    div{
      display: inline-block;
      font-size: 20px !important;
    }
    .contentTitle{
      margin-right: 30px;
    }
    .el-checkbox__input{
      line-height: 1.5;
    }
    .el-checkbox__inner{
      height: 22px;
      width: 22px;
    }
    .noticeText{
      margin-left: 0.2rem;
    }
    .el-checkbox__inner::after{
      left: 5px;
      top: 0rem;
      height: 14px;
      width: 8px;
    }
  }
}

.resetActiveIndex{
  background-color: $themeColor !important;
}

.itemWarpLine{
  display: flex;
  margin: 0 0.7rem;
  margin-bottom: 0.3rem;
  font-size: 0.35rem;
  line-height: 0.4rem;
  align-items: center;
  .notice{
    text-decoration: underline;
    margin-left: 0.3rem;
    color: #666666;
  }
  .noticeText{
    color: #666666;
    font-size: 0.35rem;
    margin-left: 0.5rem;
    line-height: 0.6rem;
  }
}
.reservation{
  .timeDetail{
    .selectedTime{
      border: 2px solid $themeColor !important;
      position: relative;
      &:after{
        bottom: 0;
        right: 0;
        display: inline-block;
        content: '';
        position: absolute;
        background-color: $themeColor;
        -webkit-mask: url('~@/assets/ticket/buttonSelect.svg') 0 0/cover no-repeat;
        mask: url('~@/assets/ticket/buttonSelect.svg') 0 0/cover no-repeat;
        // background: url('~@/assets/ticket/buttonSelect.svg') 0 0/cover no-repeat;;
      }
    }
  }
}
.reservation .pcCalendar{
  thead{
    border-bottom: 1px solid $themeColor;
    
  }
  .calendar{
    border-radius: 20px;
    overflow: hidden;
    border: 1px solid $themeColor;
    border-top-right-radius: unset;
    border-bottom-right-radius: unset;
    border-right: unset;
    margin-bottom: 50px;
  }
}
.reservation{
  .pcItemCard{
    .selectedTime{
      border-radius: 14px;
      &:after{
        width: 40px;
        height: 40px;
        bottom: -2px;
        right: -2px;
        border-bottom-right-radius: 12px;
      }
    }
  }
}

.button{
  cursor: pointer;
}

.nameDetail{
  margin-bottom: 0.3rem;
  display: flex;
  // justify-content: space-around;
  align-items: center;
  font-size: 0.4rem;
  color: #666666;
  div{
    &:nth-child(2) {
      width: 1.8rem;
      margin: 0 0.1rem;
      text-align: center;
      // margin-left: 0.5rem;
    }
    &:nth-child(3) {
      width: 4.2rem;
      margin-right: 0.3rem;
    }
  }
}
.delName{
  height: 0.5rem;
  width: 0.5rem;
  line-height: 0.5rem;
  text-align: center;
  color: $themeColor;
  border: 1px solid $themeColor;
  border-radius: 0.1rem;
  font-size: 0.3rem;
  font-weight: 500;
}

.contentTitle{
  font-weight: 500;
  font-size: 0.45rem;
  text-align: left;
  margin-right: 0.3rem;
}

// 预约详细信息
.lineContent{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 0.4rem;
  // margin-bottom: 0.5rem;
  .name{
    width: 3.6rem;
    font-weight: 500;
    text-align: left;
  }
  .el-input__inner{
    width: 5.5rem;
    border: unset;
    background: unset;
    color: #333;
    padding: 0.1rem;
    font-size: 0.38rem;
  }
}

.itemWarpLine{
  .isNoticed{
    color: $themeColor !important;
  }
}

// 身份证
.addCard{
  .cardImg, .tips{
    color: $themeColor;
  }
}
// 颜色
//personal
.personal{
  text-align: left;
  .itemCard{
    .nameBlock:nth-child(3n-1) {
      margin: 0 0.9rem;
    }
  }  
  .nameBlock{
    font-size: 0.4rem;
    display: inline-block;
    width: 2rem;
    height: 1.1rem;
    background-color: #ffffff;
    border-radius: 0.2rem;
    line-height: 1.1rem;
    // margin-right: 0.6rem;
    text-align: center;
    border: 1px solid #ffffff;
    margin-bottom: 0.5rem;
  }
  .selected{
    border: 0.03rem solid $themeColor;
    position: relative;
    width: 1.99rem;
    height: 1.09rem;
    line-height: 1.09rem;
    &:after{
      bottom: -0.02rem;
      right: 0;
      display: inline-block;
      content: '';
      position: absolute;
      width: 0.5rem;
      height: 0.5rem;
      border-bottom-right-radius: 0.19rem;
      background-color: $themeColor;
      -webkit-mask: url('~@/assets/ticket/buttonSelect.svg') 0 0/cover no-repeat;
      mask: url('~@/assets/ticket/buttonSelect.svg') 0 0/cover no-repeat;
    }
    // border: 1px solid rgab(0,0,0,0);
    // background: url('~@/assets/ticket/h5Select.png') 0 0/100% 100% no-repeat;
  }
  .add{
    color: $themeColor;
    font-size: 0.5rem;
    // line-height: 0.8rem;
    font-weight: 700;
  }
  .itemWarp{
    // margin-bottom: 0.3rem;
  }
}
// groupDetail
.groupDetail{
  .group{
    .button{
      &:nth-child(1){
        &::before{
          background-color: $themeColor;
          -webkit-mask: url('~@/assets/ticket/icon1.svg') 0 0/cover no-repeat;
          mask: url('~@/assets/ticket/icon1.svg') 0 0/cover no-repeat;
        }
      }
      &:nth-child(2){
        &::before{
          background-color: $themeColor;
          -webkit-mask: url('~@/assets/ticket/share.svg') 0 0/cover no-repeat;
          mask: url('~@/assets/ticket/share.svg') 0 0/cover no-repeat;
        }
      }
    }
  }
}
.groupShare{
  // padding: .5rem;
  .code{
    font-size: 0.55rem;
    font-weight: 500;
  }
  .codeNumber{
    font-size: 1rem;
    color: $themeColor;
    line-height: 1.8rem;
    border: solid 1px #e5e5e5;
    padding: 0 0.3rem;
    width: 5.5rem;
    margin: 0.4rem auto;
    border-radius: 0.4rem;
    letter-spacing: 0.4rem;
    font-weight: 500;
  }
  p{
    font-size: 0.35rem;
    margin-bottom: 0.4rem;
  }
}
// groupCode
.groupCode input{
  color:$themeColor;
}
.personalCard{
  border: 0.02rem solid $themeColor;
}

// re_success
.rightContent{
  width: 6.8rem;
  .detail{
    font-size: 0.4rem;
    line-height: 0.8rem;
    text-align: left;
    .title{
      margin-right: 0.7rem;
      font-weight: 500;
    }
    .name{
      font-size: 0.35rem;
    }
  }
}
.reSuccess .showErCode{
  color: $themeColor;
  border: 1px solid $themeColor;
}
.leftLine{
  border-right: 2px solid $themeColor;
}
.reSuccess{
  .pcContent .pcItemCard .reTime span{
    color: $themeColor;
  }
}

// tabs
.tabs{
  .activeTab{
    background-color: $themeColor;
  }
}

.pcTabs{
  border-bottom: 1px solid $themeColor;
  .activeTab{
    color: $themeColor;
  }
}

.leftName{
  max-width: 1.1rem;
  font-size: 0.45rem;
  display: inline-flex;
  line-height: 0.6rem;
  font-weight: 500;
  height: 3.6rem;
  display: flex;
  justify-content: center;
  margin: auto;
  writing-mode: vertical-lr;
  overflow: hidden;
  letter-spacing: 0.1rem;
}

.buttonsWarp{
  display: flex;
  justify-content: center;
  align-items: center;
  .upload-demo{
    margin-right: 50px;
  }
  .upload-demo, .button3{
    width: 330px !important;
    height: 80px !important;
    line-height: 80px;
  }
}

.lineText{
  font-size: 0.55rem;
  font-weight: 500;
}
.handelBlock{
  .line{
    span{
      color: $themeColor;
    }
  }
}
/*element*/
// 组合单选框
.el-radio__input.is-checked .el-radio__inner{
  border-color: $themeColor !important;
  background: #fff !important;
}
.el-radio__input.is-checked+.el-radio__label{
  color: $themeColor !important;
}

.el-radio__inner{
  border: 1px solid $themeColor !important;
}

.itemWarp .el-input__inner{
  border: unset;
  background: unset;
}

// 选择框
.el-select-dropdown__item.selected{
  color: $themeColor !important;
}

.el-radio__inner::after{
  height: 8px !important;
  width: 8px !important;
  background-color: $themeColor !important;
}

// 复选框

.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
  background-color: $themeColor !important;
  border-color: $themeColor !important;
}

.el-checkbox__inner{
  border-radius: 50% !important;
  border: 1px solid $themeColor !important;
}

.el-checkbox__input.is-checked+.el-checkbox__label{
  color: $themeColor !important;
}

// 页码
.el-pagination.is-background .el-pager li:not(.disabled).active{
  background-color: #ffffff !important;
  border: 1px solid $themeColor;
  color: $themeColor !important;
}

.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{
  background-color: #ffffff !important;
  color: #666666 !important;
}

.buttonRed .el-input__inner{
  font-size: 20px;
  line-height: 56px !important;
  height: 56px !important;
}
.buttonRed .el-input__suffix{
  right: 40px;
  top: -3px;
}
.el-select-dropdown__item{
  font-size: 16px !important;
}
.isMobile .upload-demo{
  margin-top: -0.15rem;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
 
input[type="number"] {
  -moz-appearance: textfield;
}
.el-select{
  width: 100%;
}
.el-input.is-disabled .el-input__inner{
  color: #333333ad;
}
@media screen and (max-width: 1200px){
  .reservation.isPc{
    min-width: 1200px;
  }
}
.el-radio__input.is-checked .el-radio__inner{box-shadow: none !important;
}
</style>
